import { Col } from "react-bootstrap";
import styled from "styled-components";

export const LabelCol = styled(Col)`
  font-weight: 500;
`;
